import SlidingMenu from './SlidingMenu';
export default SlidingMenu;
